import { render } from "./App.vue?vue&type=template&id=4ae945c7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4ae945c7&lang=css"

import exportComponent from "/var/www/html/p23_selfpayment_pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__